import { Icon } from "next/dist/lib/metadata/types/metadata-types";

import { BaseEntry, CustomLink, ImageElement, textImage } from "@/types";

export interface History extends BaseEntry {
  variant: HistoryVariants;
  years: HistoryYear[];
}
export interface HistoryYear extends BaseEntry {
  title: string;
  year?: number;
  cards: HistoryCard[];
}
export interface HistoryCard extends BaseEntry {
  overtitle?: string;
  displayOvertitle: boolean;
  title: string;
  description: string;
  icon?: CustomLink;
  cta?: CustomLink;
  backgroundImage: ImageElement;
  mobileBackgroundImage?: ImageElement;
  modal?: HistoryModal;
  cardBackgroundColor?: string;
  cardBackgroundOpacity?: number;
}
interface HistoryModal extends textImage {
  label: string;
}

export enum HistoryVariants {
  years = "Years",
  icons = "Icons",
}
